export const SEND_VERIFICATION_CODE = 'SEND_VERIFICATION_CODE';
export const UPDATE_FORGOT_PASSWORD_STATUS = 'UPDATE_FORGOT_PASSWORD_STATUS';
export const SUBMIT_VERIFICATION_CODE = 'SUBMIT_VERIFICATION_CODE';